import { warn } from "@swivl-mono/helpers";
import { Channel, DoesSessionHaveActiveEscalation, EscalationInterface, IsSessionTakenOver, SessionInterface, UserInterface } from "@swivl-mono/types";
import { Button } from "@swivl-mono/ui";
import { ChannelColors } from "../../../../../Helpers/Conversations/Conversations.Helper";
import useHasPendingUpdates from "../../../../../Hooks/useHasPendingUpdates";
import { Member } from "../../../../../Models/Member/Member.Current";
import MembersModel from "../../../../../Models/Member/Members.Model";
import { PendingUpdateType } from "../../../../../Models/Pending/Pending.Model";
import { UserConversationsInterface, UsersModel } from "../../../../../Models/Users/Users.Model";

interface ChatFooterTakenOverProps {
  user: UserInterface;
  conversation?: UserConversationsInterface,
  channel: Channel;
  currentChannelColor: typeof ChannelColors[Channel];
  session?: SessionInterface;
  escalation?: EscalationInterface;
}
export function ChatFooterNotTakenOverComponent(props: ChatFooterTakenOverProps) {
  const { conversation, channel, currentChannelColor, session, escalation, user } = props;
  const membersMap = MembersModel.useState((state) => state.membersMap);
  const hasPendingUpdates = useHasPendingUpdates([
    { type: PendingUpdateType.SESSION_ESCALATION, id: session?.id || "" },
    { type: PendingUpdateType.TAKING_OVER_ON_CHANNEL, id: channel }
  ]);

  /* Scenarios: 
  1) Session is not taken over. Chat.
  2) Session has escalation and it is pending / assigned to someone else.
  3) Session has escalation and it is assigned to me.
  4) Session has escalation and taken over by another agent.
  */
  const handleTakeover = () => {
    if (user) {
      UsersModel.takeoverConversationOnChannel(user.id, channel)
    } else {
      warn("No escalation found for this conversation.", conversation, session, escalation);
    }
  };

  const acceptEscalation = () => {
    if (escalation) {
      UsersModel.acceptEscalation(escalation);
    } else {
      warn("No escalation found for this conversation.", conversation);
    }
  }

  const isSessionTaken = IsSessionTakenOver(session);
  const doesSessionHaveActiveEscalation = DoesSessionHaveActiveEscalation(session);

  let actionText = channel === Channel.VOICE ? "is on a call with" : "is chatting with";
  let currentAgentName = "the automated bot.";
  let buttons = (
    <Button
      color={currentChannelColor.buttonColor}
      loading={hasPendingUpdates}
      onClick={handleTakeover}
    >
      Takeover
    </Button>
  );

  if (!doesSessionHaveActiveEscalation) {
    // scenario 1
    // No action needed? 
  } else if (doesSessionHaveActiveEscalation) {
    if (!isSessionTaken) {
      if (escalation?.assignedMemberId !== Member.id) {
        // Scenario 2
        actionText = "is waiting for another agent.";
        currentAgentName = "";
      } else {
        // Scenario 3 
        actionText = "Is assigned to you.";
        currentAgentName = "";
        buttons = (
          <Button
            color={currentChannelColor.buttonColor}
            loading={hasPendingUpdates}
            onClick={acceptEscalation}
          >
            Accept
          </Button>
        );
      }
    } else {
      // Scenario 4
      currentAgentName = membersMap && escalation?.assignedMemberId && membersMap[escalation?.assignedMemberId].agentName ? membersMap[escalation.assignedMemberId].agentName! : "another agent.";
      buttons = <></>;
    }
  }

  return (
    <div className="flex flex-col items-center justify-center text-center gap-2 py-4">
      <span className="italic">This customer {actionText} {currentAgentName}</span>
      {buttons}
    </div>
  );
}
